const expandedIdsFor = (ids, id, mode) => mode === 'multiple' ? [...new Set([...ids, id])] : [id];

/** Presentation navigation only; never selects a canonical workspace project. */
export const initialSidebarNavigation = () => ({ expandedIds: [], armedId: '' });

export const resolveSidebarNavigation = (state, intent, expansionMode = 'single') => {
  const { projectId = '', type } = intent;
  const expanded = state.expandedIds.includes(projectId);
  const opening = [type === 'open', type === 'click' && expanded].some(Boolean);
  const rules = [
    { matches: type === 'reset' || !projectId, action: 'none',
      next: { ...state, armedId: '' } },
    { matches: opening, action: 'open_project', next: { ...state, armedId: '' } },
    { matches: type === 'toggle' && expanded, action: 'browse',
      next: { expandedIds: state.expandedIds.filter(id => id !== projectId), armedId: '' } },
    { matches: true, action: 'browse', next: {
      expandedIds: expandedIdsFor(state.expandedIds, projectId, expansionMode),
      armedId: type === 'click' ? projectId : '',
    } },
  ];
  const decision = rules.find(rule => rule.matches);
  return { state: decision.next, action: decision.action, projectId };
};
